import React, {Component} from 'react';
import ReactDOM from "react-dom";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import AdditionalPayment from '../services/AdditionalPayment';
import Refund from '../services/Refund';
import Loader from "react-loader-spinner";

class RenderPayments extends Component {

    constructor(props) {
        super(props);

        this.togglePaymentModal = this.togglePaymentModal.bind(this);
        this.toggleRefundModal = this.toggleRefundModal.bind(this);
        this.handlePaymentInputChange = this.handlePaymentInputChange.bind(this);
        this.handleAdditionalPayment = this.handleAdditionalPayment.bind(this);
        this.roundInput = this.roundInput.bind(this);
        this.handleRefund = this.handleRefund.bind(this);

        this.AdditionalPayment = new AdditionalPayment();
        this.Refund = new Refund();

        this.state = {
            togglePayment: false,
            toggleRefund: false,
            paymentError: {},
            refundError: {},
            paymentSuccess: false,
            loading: false,
            refund_loading: false,
            disabled: false,
            disabledRefund: false,
            amount: '',
            refund_amount: ''
        };
    }

    togglePaymentModal(e) {
        e.preventDefault();
        this.setState({
            togglePayment: !this.state.togglePayment,
            paymentError: {},
            refundError: {},
            paymentSuccess: false,
            loading: false,
            disabled: false,
            amount: ''
        })
    }

    toggleRefundModal(payment = null, charge = null) {
        this.setState({
            toggleRefund: !this.state.toggleRefund,
            modalRefundPayment: payment,
            modalRefundCharge: charge
        })
    }

    handlePaymentInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            disabled: false
        })
    }

    handleRefundInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            disabledRefund: false
        });
    }

    handleAdditionalPayment() {
        let data = {
            amount: this.state.amount,
            order: this.props.order,
            user: this.props.user
        };

        this.setState({
            loading: true,
            disabled: true
        }, () => {
            this.AdditionalPayment.createAdditionalPayment(data)
                .then(res => {
                    this.setState({
                        loading: false
                    });
                    if (res.data.success) {
                        window.location.reload();
                    }
                });
        });

    }

    handleRefund() {
        let data = {
            amount: this.state.refund_amount,
            payment: this.state.modalRefundPayment,
            charge: this.state.modalRefundCharge
        };

        // console.log(data);
        //
        this.setState({
            refund_loading: true,
            disabledRefund: true,
            refundError: {}
        }, () => {
            this.Refund.refund(data)
                .then(res => {
                    this.setState({
                        refund_loading: false
                    });
                    if (res.data.success) {
                        window.location.reload();
                    }
                })
                .catch(err => {
                    this.setState({
                        refundError: err.response.data,
                        refund_loading: false
                    })
                });
        });
    }

    roundInput(e) {
        this.setState({
            amount: Math.round(e.target.value * 100) / 100
        });
    }

    render() {
        return (
            <React.Fragment>
                {this.props.payments.map((payment, i) => {
                    return (
                        <React.Fragment key={i}>
                            <div className="row pt-3">
                                <div className="col-md-12">
                                    <h5 className="text-muted">Payment:</h5>
                                    <hr/>
                                </div>
                            </div>
                            <div className="row" key={payment.id}>
                                <div className="col-md-3">
                                    <div className="text-muted">Payment id, Stripe id:</div>
                                    <div className="order-item text-muted">
                                        <strong>{payment.id}, {payment.charge_id}</strong>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="text-muted">Amount:</div>
                                    <div className="order-item text-muted">
                                        <strong>&#163;{payment.amount / 100}</strong>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="text-muted">Status:</div>
                                    <div className="order-item text-muted">
                                        <strong>{payment.status}</strong>
                                    </div>
                                </div>
                                <div className="col-md-3 d-flex flex-column justify-content-between">
                                    {payment.status !== 'pending' &&
                                    <React.Fragment>
                                        <div className="text-muted">Options:</div>
                                        <div>
                                            <div>
                                                <a href="#"
                                                   className="btn btn-sm btn-danger add-refund"
                                                   onClick={() => this.toggleRefundModal(payment.id, payment.charge_id)}>
                                                    <i className="fa fa-money"></i>refund
                                                </a>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                    }
                                </div>
                            </div>
                            {payment.refunds.length > 0 &&
                            <React.Fragment>
                                <div className="row pt-2">
                                    <div className="col-md-12">
                                        <h5 className="text-muted pt-3">Refunds for this payment:</h5>
                                    </div>
                                </div>
                                {payment.refunds.map((refund) => {
                                    return (
                                        <div className="row pt-2" key={refund.id}>
                                            <div className="col-md-3">
                                                <div className="text-muted">Refund id, Stripe id:</div>
                                                <div className="order-item text-muted">
                                                    <strong>{refund.id}, {refund.refund_id}</strong>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="text-muted">Amount:</div>
                                                <div className="order-item text-muted">
                                                    <strong> &#163;{refund.amount / 100}</strong>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="text-muted">Status:</div>
                                                <div className="order-item text-muted">
                                                    <strong>{refund.status}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <hr/>
                            </React.Fragment>
                            }
                        </React.Fragment>
                    );
                })}

                <Modal isOpen={this.state.togglePayment} toggle={this.togglePaymentModal}
                       className={'modal-lg modal-dialog-centered'}>
                    <ModalHeader toggle={this.togglePaymentModal}>Create additional payment</ModalHeader>
                    <ModalBody>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="typeImage">Enter amount:</label>
                                    <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">&#163;</div>
                                        </div>
                                        <input className="form-control"
                                               name="amount"
                                               type="number"
                                               placeholder="Amount..."
                                               value={this.state.amount}
                                               onChange={(e) => this.handlePaymentInputChange(e)}
                                               onBlur={(e) => this.roundInput(e)}/>
                                        {this.state.paymentError &&
                                        <div>
                                            <small>{this.state.paymentError.message}</small>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="form-group text-right">
                                    <button className='btn btn-round btn-payment'
                                            onClick={(ev) => this.handleAdditionalPayment(ev)}
                                            disabled={this.state.disabled || this.state.amount === '' || this.state.amount == '0'}>
                                        <div className='d-flex flex-row justify-content-center'>
                                            {this.state.loading &&
                                            <div style={{
                                                display: 'inline-block',
                                                paddingRight: '5px',
                                            }}>
                                                <Loader type="Oval" color="#514f4c" height={15} width={15}/>
                                            </div>
                                            }
                                            <div>Create</div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.toggleRefund} toggle={this.toggleRefundModal}
                       className={'modal-lg modal-dialog-centered'}>
                    <ModalHeader toggle={this.toggleRefundModal}>Create refund</ModalHeader>
                    <ModalBody>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="typeImage">Enter amount:</label>
                                    <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">&#163;</div>
                                        </div>
                                        <input className="form-control"
                                               name="refund_amount"
                                               type="number"
                                               placeholder="Amount..."
                                               value={this.state.refund_amount}
                                               onChange={(e) => this.handleRefundInputChange(e)}
                                               onBlur={(e) => this.roundInput(e)}/>
                                        {this.state.refundError &&
                                        <div>
                                            <small className='text-danger'>{this.state.refundError.message}</small>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="form-group text-right">
                                    <button className='btn btn-round btn-payment'
                                            onClick={(ev) => this.handleRefund(ev)}
                                            disabled={this.state.disabledRefund || this.state.refund_amount === '' || this.state.refund_amount == '0'}>
                                        <div className='d-flex flex-row justify-content-center'>
                                            {this.state.refund_loading &&
                                            <div style={{
                                                display: 'inline-block',
                                                paddingRight: '5px',
                                            }}>
                                                <Loader type="Oval" color="#514f4c" height={15} width={15}/>
                                            </div>
                                            }
                                            <div>Refund</div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                {/*<a href="#"*/}
                {/*className="btn btn-sm btn-success add-payment"*/}
                {/*onClick={this.togglePaymentModal}>*/}
                {/*<i className="fa fa-money"></i> new request*/}
                {/*</a>*/}
                <div className="row pt-3">
                    <div className="col-md-9">
                        <button className='btn btn-block btn-success add-payment' onClick={(e) => this.togglePaymentModal(e)}><i className="fa fa-money"></i> New payment request</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

if (document.getElementById('renderPayments')) {
    let element = document.getElementById('renderPayments');
    ReactDOM.render(<RenderPayments payments={JSON.parse(element.dataset.payments)} order={element.dataset.order}
                                    user={element.dataset.user}/>, element);
}


export default RenderPayments;

